import React from 'react';

import AuthPromoTextPopup from 'apps/auth/components/calculator/AuthPromoTextPopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { ALIPAY_FREE, MASTERCARD_FREE } from 'apps/auth/constants/FieldType';
import { URL_IMAGES_PAYSYSTEMS } from 'apps/auth/constants/UrlConstants';

import { Container, IconWrapper } from './styles';

const GiftBlock = (props) => {
    const getIcon = () => {
        if (props.promoAction.type === ALIPAY_FREE) {
            return { url: `${URL_IMAGES_PAYSYSTEMS}/alipay.svg` };
        } else if (props.promoAction.type === MASTERCARD_FREE) {
            return { url: `${URL_IMAGES_PAYSYSTEMS}/mastercard_color.svg` };
        }
    };

    return (
        <Container
            onClick={() => {
                props.popupRef.current.open(
                    <AuthPromoTextPopup
                        countryToId={props.countryToId}
                        isComment={true}
                        type={props.promoAction.type}
                        text={props.promoAction.modalBlockText}
                        popupRef={props.popupRef}
                    />,
                );
            }}
        >
            <Text>{props.promoAction.title}</Text>
            <IconWrapper>
                <img src={getIcon()} alt={'paysystem'} />
            </IconWrapper>
        </Container>
    );
};

export default GiftBlock;
